import React, { useContext, useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import axios from "axios";
import packageJson from "../../package.json";

const BASE_URL = packageJson.apiUrl;

const TopBar = () => {
  const { cart } = useContext(CartContext);
  const user = JSON.parse(localStorage.getItem("user"));
  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchError, setSearchError] = useState("");

  // Debounce timeout ref
  let debounceTimer;

  const fetchSearchResults = useCallback(async (query) => {
    if (!query || query.length < 3) {
      setSearchResults([]);
      setSearchError(
        query.length > 0 ? "Please enter at least 3 characters." : ""
      );
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}/course/search`, {
        params: { search: query },
      });

      setSearchResults(response.data.results);

      if (response.data.results.length === 0) {
        setSearchError("No courses found for the given search query.");
      } else {
        setSearchError("");
      }
    } catch (error) {
      console.error("Error searching courses:", error);
      setSearchError("No courses found");
      setSearchResults([]);
    }
  }, []);

  // Handle input typing with debounce
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetchSearchResults(value);
    }, 500); // wait 500ms after user stops typing
  };

  const handleClick = (text) => {
    localStorage.setItem("categoryName", text);
    setSearchQuery(""); // Clear input
    setSearchResults([]); // Close list
    setSearchError("");
  };

  return (
    <section className="sec-top">
      <div className="container-xl">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-2 d-none d-lg-block d-md-none my-auto">
            <p className="top-p">Welcome</p>
          </div>
          <div className="col-lg-6 col-md-10 col-10 my-auto">
            <div className="top-search-box">
              <div className="top-search">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Course"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    aria-describedby="basic-addon2"
                  />
                  <div className="input-group-append">
                    <button className="btn btn-outline-secondary" type="button" disabled>
                      <i className="bi bi-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              {searchError && (
                <div className="alert alert-danger mt-2" role="alert">
                  {searchError}
                </div>
              )}
              {searchResults.length > 0 && (
                <ul className="navbar-nav me-auto ms-auto">
                  {searchResults.map((result, index) => (
                    <li key={index}>
                      <Link
                        to={`/course-detail/${result.id}`}
                        onClick={() => handleClick(result.name)}
                      >
                        {result.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          {!(user?.role === "individual" && user?.parent !== 0) && (
            <div className="col-lg-3 col-md-2 col-2 text-end my-auto">
              <Link to="/cart" className="m-cart">
                <i className="bi bi-cart"></i>
                {cartCount > 0 && (
                  <span className="cart-count">{cartCount}</span>
                )}
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TopBar;
